import React from 'react';

type IconProps = { className?: string };

const svg = (children: React.ReactNode, p: IconProps = {}) => (
    <svg
        className={p.className}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.7}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        focusable="false"
    >
        {children}
    </svg>
);

export const HobbyIconHeadphones = (p?: IconProps) =>
    svg(
        <>
            <path d="M4 14v-2a8 8 0 0 1 16 0v2" />
            <rect x="2.5" y="13.5" width="4" height="7" rx="2" />
            <rect x="17.5" y="13.5" width="4" height="7" rx="2" />
        </>,
        p
    );

export const HobbyIconBook = (p?: IconProps) =>
    svg(
        <>
            <path d="M4 4.5h6a3 3 0 0 1 3 3V20a2.5 2.5 0 0 0-2.5-2.5H4z" />
            <path d="M20 4.5h-6a3 3 0 0 0-3 3V20a2.5 2.5 0 0 1 2.5-2.5H20z" />
        </>,
        p
    );

export const HobbyIconCamera = (p?: IconProps) =>
    svg(
        <>
            <rect x="2.5" y="6.5" width="19" height="13" rx="2.5" />
            <circle cx="12" cy="13" r="4" />
            <path d="M8.5 6.5 10 4h4l1.5 2.5" />
        </>,
        p
    );

export const HobbyIconPlane = (p?: IconProps) =>
    svg(
        <>
            <path d="M21.5 3 2.5 11l7.5 2.8L13 21z" />
            <path d="M21.5 3 10 13.8" />
        </>,
        p
    );

export const HobbyIconGamepad = (p?: IconProps) =>
    svg(
        <>
            <rect x="2.5" y="7.5" width="19" height="11" rx="4" />
            <path d="M7 11v4M5 13h4" />
            <circle cx="16" cy="12.5" r="1" />
            <circle cx="18.5" cy="15" r="1" />
        </>,
        p
    );

export const HobbyIconBike = (p?: IconProps) =>
    svg(
        <>
            <circle cx="5.5" cy="17" r="3.5" />
            <circle cx="18.5" cy="17" r="3.5" />
            <path d="M5.5 17l4-8h5l-4 8h8" />
            <path d="M14 9h3" />
        </>,
        p
    );

export const HobbyIconPalette = (p?: IconProps) =>
    svg(
        <>
            <path d="M12 3a9 9 0 0 0 0 18 2 2 0 0 0 1.6-3.2 2 2 0 0 1 1.6-3.2H18a3 3 0 0 0 3-3c0-4.6-4-8.6-9-8.6z" />
            <circle cx="7.5" cy="12.5" r="1" />
            <circle cx="9.5" cy="8.5" r="1" />
            <circle cx="14" cy="7.5" r="1" />
        </>,
        p
    );

export const HobbyIconMusic = (p?: IconProps) =>
    svg(
        <>
            <path d="M9 18V6l11-2v12" />
            <circle cx="6" cy="18" r="3" />
            <circle cx="17" cy="16" r="3" />
        </>,
        p
    );

export const HobbyIconFilm = (p?: IconProps) =>
    svg(
        <>
            <rect x="2.5" y="4.5" width="19" height="15" rx="2" />
            <path d="M7 4.5v15M17 4.5v15M2.5 12h19" />
        </>,
        p
    );

export const HobbyIconCoffee = (p?: IconProps) =>
    svg(
        <>
            <path d="M4 8h13v6a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5z" />
            <path d="M17 9.5h1.5a2.5 2.5 0 0 1 0 5H17" />
            <path d="M6 3v2M10 3v2M14 3v2" />
        </>,
        p
    );

export const HobbyIconDumbbell = (p?: IconProps) =>
    svg(
        <>
            <path d="M6.5 8.5v7M17.5 8.5v7M4 10.5v3M20 10.5v3M6.5 12h11" />
            <rect x="2" y="9" width="2.5" height="6" rx="0.8" />
            <rect x="19.5" y="9" width="2.5" height="6" rx="0.8" />
        </>,
        p
    );

export const HobbyIconRun = (p?: IconProps) =>
    svg(
        <>
            <circle cx="14" cy="5" r="2" />
            <path d="M8 21l2.5-5 3 2 2-4 3 1" />
            <path d="M6 12l3-1 2.5 2.5" />
        </>,
        p
    );

export const HobbyIconCook = (p?: IconProps) =>
    svg(
        <>
            <path d="M8 11c0-3 1.5-5 4-5s4 2 4 5" />
            <path d="M6 11h12v2a6 6 0 0 1-12 0z" />
            <path d="M12 6V3" />
        </>,
        p
    );

export const HobbyIconCode = (p?: IconProps) =>
    svg(
        <>
            <path d="M8 8 4 12l4 4" />
            <path d="M16 8l4 4-4 4" />
            <path d="M13 6l-2 12" />
        </>,
        p
    );

export const HobbyIconCar = (p?: IconProps) =>
    svg(
        <>
            <path d="M3 14h18v3a1.5 1.5 0 0 1-1.5 1.5H4.5A1.5 1.5 0 0 1 3 17z" />
            <path d="M5 14 6.5 8.5h11L19 14" />
            <circle cx="7.5" cy="17.5" r="1.5" />
            <circle cx="16.5" cy="17.5" r="1.5" />
        </>,
        p
    );

export const HobbyIconHeart = (p?: IconProps) =>
    svg(<path d="M12 20s-7-4.5-7-10a4 4 0 0 1 7-2.5A4 4 0 0 1 19 10c0 5.5-7 10-7 10z" />, p);

export const HobbyIconMountain = (p?: IconProps) =>
    svg(
        <>
            <path d="M3 19 9 8l3.5 5.5L15 10l6 9z" />
            <path d="M12.5 13.5 14 11l2 3" />
        </>,
        p
    );

export const HobbyIconSwim = (p?: IconProps) =>
    svg(
        <>
            <circle cx="16" cy="6" r="2" />
            <path d="M3 16c1.5-1 3-1 4.5 0s3 1 4.5 0 3-1 4.5 0 3 1 4.5 0" />
            <path d="M3 20c1.5-1 3-1 4.5 0s3 1 4.5 0 3-1 4.5 0 3 1 4.5 0" />
            <path d="M10 10l2 3 3-1" />
        </>,
        p
    );

export const HobbyIconBall = (p?: IconProps) =>
    svg(
        <>
            <circle cx="12" cy="12" r="9" />
            <path d="M12 3a12 12 0 0 1 0 18M12 3a12 12 0 0 0 0 18M3 12h18" />
        </>,
        p
    );

export const HobbyIconPet = (p?: IconProps) =>
    svg(
        <>
            <ellipse cx="12" cy="15" rx="5" ry="4" />
            <circle cx="7" cy="10" r="1.8" />
            <circle cx="17" cy="10" r="1.8" />
            <circle cx="9.5" cy="7" r="1.5" />
            <circle cx="14.5" cy="7" r="1.5" />
        </>,
        p
    );

export const HobbyIconStar = (p?: IconProps) =>
    svg(<path d="M12 3.5 14.2 9l5.8.5-4.4 3.8 1.4 5.7L12 16.2 6.9 19l1.4-5.7L4 9.5 9.8 9z" />, p);

export type MagentaHobbyIcon = (props?: IconProps) => React.ReactElement;

export type MagentaHobbyOption = {
    /** Stocké dans interest.name — identifiant stable */
    id: string;
    label: string;
    Icon: MagentaHobbyIcon;
};

/** Catalogue d’icônes sélectionnables (Magenta Ribbon uniquement). */
export const MAGENTA_HOBBY_OPTIONS: MagentaHobbyOption[] = [
    { id: 'headphones', label: 'Musique / Écoute', Icon: HobbyIconHeadphones },
    { id: 'music', label: 'Musique', Icon: HobbyIconMusic },
    { id: 'book', label: 'Lecture', Icon: HobbyIconBook },
    { id: 'camera', label: 'Photographie', Icon: HobbyIconCamera },
    { id: 'plane', label: 'Voyage', Icon: HobbyIconPlane },
    { id: 'gamepad', label: 'Jeux vidéo', Icon: HobbyIconGamepad },
    { id: 'bike', label: 'Vélo', Icon: HobbyIconBike },
    { id: 'palette', label: 'Art', Icon: HobbyIconPalette },
    { id: 'film', label: 'Cinéma', Icon: HobbyIconFilm },
    { id: 'coffee', label: 'Café', Icon: HobbyIconCoffee },
    { id: 'dumbbell', label: 'Fitness', Icon: HobbyIconDumbbell },
    { id: 'run', label: 'Course', Icon: HobbyIconRun },
    { id: 'cook', label: 'Cuisine', Icon: HobbyIconCook },
    { id: 'code', label: 'Informatique', Icon: HobbyIconCode },
    { id: 'car', label: 'Automobile', Icon: HobbyIconCar },
    { id: 'heart', label: 'Bénévolat', Icon: HobbyIconHeart },
    { id: 'mountain', label: 'Randonnée', Icon: HobbyIconMountain },
    { id: 'swim', label: 'Natation', Icon: HobbyIconSwim },
    { id: 'ball', label: 'Sport', Icon: HobbyIconBall },
    { id: 'pet', label: 'Animaux', Icon: HobbyIconPet },
    { id: 'star', label: 'Autre', Icon: HobbyIconStar },
];

export const MAGENTA_HOBBY_MAX = 8;

const normalizeHobby = (value: string) =>
    value
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim();

/** Résout l’icône depuis un id catalogue ou un ancien libellé libre. */
export const resolveMagentaHobbyIcon = (name: string, index = 0): MagentaHobbyIcon => {
    const n = normalizeHobby(name || '');
    if (n) {
        const byId = MAGENTA_HOBBY_OPTIONS.find((o) => o.id === n);
        if (byId) return byId.Icon;

        const byLabel = MAGENTA_HOBBY_OPTIONS.find((o) => normalizeHobby(o.label) === n);
        if (byLabel) return byLabel.Icon;

        // Compatibilité anciens textes libres
        const keywordHits: { keys: string[]; Icon: MagentaHobbyIcon }[] = [
            { keys: ['music', 'musique', 'guitare', 'guitar', 'piano', 'chant'], Icon: HobbyIconMusic },
            { keys: ['casque', 'headphone', 'écoute', 'ecoute'], Icon: HobbyIconHeadphones },
            { keys: ['lecture', 'lire', 'book', 'reading', 'livre'], Icon: HobbyIconBook },
            { keys: ['photo', 'camera'], Icon: HobbyIconCamera },
            { keys: ['voyage', 'travel', 'avion', 'plane'], Icon: HobbyIconPlane },
            { keys: ['jeu', 'game', 'gaming', 'console'], Icon: HobbyIconGamepad },
            { keys: ['velo', 'bike', 'cyclisme'], Icon: HobbyIconBike },
            { keys: ['art', 'dessin', 'peinture', 'palette', 'design'], Icon: HobbyIconPalette },
            { keys: ['cinema', 'film', 'movie', 'serie'], Icon: HobbyIconFilm },
            { keys: ['cafe', 'coffee', 'the', 'tea'], Icon: HobbyIconCoffee },
            { keys: ['fitness', 'gym', 'muscu'], Icon: HobbyIconDumbbell },
            { keys: ['course', 'run', 'running', 'footing'], Icon: HobbyIconRun },
            { keys: ['cuisine', 'cook', 'chef'], Icon: HobbyIconCook },
            { keys: ['code', 'dev', 'informatique', 'tech'], Icon: HobbyIconCode },
            { keys: ['voiture', 'auto', 'car', 'moto'], Icon: HobbyIconCar },
            { keys: ['benevolat', 'volunteer', 'heart', 'famille'], Icon: HobbyIconHeart },
            { keys: ['randonnee', 'hiking', 'montagne', 'nature'], Icon: HobbyIconMountain },
            { keys: ['natation', 'swim', 'piscine'], Icon: HobbyIconSwim },
            { keys: ['foot', 'sport', 'basket', 'tennis', 'ball'], Icon: HobbyIconBall },
            { keys: ['animal', 'chien', 'chat', 'pet'], Icon: HobbyIconPet },
        ];
        for (const entry of keywordHits) {
            if (entry.keys.some((k) => n.includes(normalizeHobby(k)))) return entry.Icon;
        }
    }
    return MAGENTA_HOBBY_OPTIONS[index % MAGENTA_HOBBY_OPTIONS.length].Icon;
};

export const getMagentaHobbyOption = (name: string) =>
    MAGENTA_HOBBY_OPTIONS.find((o) => o.id === name || normalizeHobby(o.label) === normalizeHobby(name));
